module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "title": "CREATE NEW FOLDER",
      "id": _vm.id,
      "value": _vm.value,
      "extra-class": "modal-sm"
    },
    on: {
      "shown": _vm.clear,
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('button', {
          staticClass: "btn green mt-ladda-btn ladda-button add-folder-button",
          attrs: {
            "data-style": "expand-left"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.createFolder(_vm.addFolderName)
            }
          }
        }, [_c('span', {
          staticClass: "ladda-label"
        }, [_vm._v("Add Folder")])]), _vm._v(" "), _c('button', {
          staticClass: "btn default",
          attrs: {
            "data-dismiss": "modal"
          }
        }, [_vm._v("Cancel")])]
      },
      proxy: true
    }])
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "add-folder"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('add-folder.name')
    }
  }, [_c('label', {
    attrs: {
      "for": "add-folder-name"
    }
  }, [_vm._v("Folder Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addFolderName),
      expression: "addFolderName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "add-folder-name",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.addFolderName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addFolderName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('add-folder.name')),
      expression: "errors.has('add-folder.name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('add-folder.name')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76c8764e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/reports/CreateFolderModal.vue
// module id = 1702
// module chunks = 1